module.exports = __webpack_public_path__ + "assets/img/thumb_ch4_news-item-0.603ad4d5.jpg";